/**
 * API Client for Feature Flags.
 *
 * Wraps GET /api/v2/feature-flags/check.
 * Returns the subset of requested flag names that are currently enabled
 * for the authenticated workspace.
 */
import { apiClient } from '@/lib/api-client';

const API_BASE = '/api/v2';

export interface CheckResponse {
  enabled: string[];
}

/**
 * Bulk-check whether a set of feature flags are enabled for the current workspace.
 *
 * @param names - Flag names to check (e.g. ['tool.amazon_title', 'behavior.use_presets_naming'])
 * @returns Object with `enabled` array containing only the active flag names.
 */
export async function checkFeatureFlags(names: string[]): Promise<CheckResponse> {
  if (names.length === 0) return { enabled: [] };
  const { data } = await apiClient.get<CheckResponse>(
    `${API_BASE}/feature-flags/check`,
    { params: { names: names.join(',') } },
  );
  return data;
}
